import * as Yup from 'yup'

export const validationSchema = Yup.object().shape({
  additionalFacts: Yup.array().of(
    Yup.object().shape({
      id: Yup.string().required(),
      value: Yup.string().nullable(),
    })
  ),
})
